import { camelizeKeys } from '@skytech/utils'

import type { MyAssetsAsset } from '@/components/my-assets/types'
import { get, post } from '@/util/auth'

/* Note. The injury report API is for historical reasons used to get assets+injuryReports for MyAssets view */
/* MyAssets in app started out as part of the injury report feature, but is now a general MyAssets view */

const injuryreportResources = {
  getAssetList: async () => {
    const assets = await get<Record<string, unknown>[]>('app/injury-report/assets')
    const parsedData = camelizeKeys(assets)

    const parsedDataTyped = parsedData as MyAssetsAsset[]
    return parsedDataTyped.sort((a, b) => {
      // 1 Assets WITH buyout offering first
      const aHasBuyout = !!a.buyoutOffering
      const bHasBuyout = !!b.buyoutOffering

      if (aHasBuyout !== bHasBuyout) {
        return aHasBuyout ? -1 : 1
      }

      // 2️2 Closest expiration date first (only if both have buyout)
      if (aHasBuyout && bHasBuyout) {
        const aExpiry = new Date(a.buyoutOffering!.offerExpirationDate).getTime()
        const bExpiry = new Date(b.buyoutOffering!.offerExpirationDate).getTime()

        if (aExpiry !== bExpiry) {
          return aExpiry - bExpiry
        }
      }

      // 3️3 Fallback: statusId
      return a.statusId - b.statusId
    })
  },

  // mutations
  post: async (assetId: number) => {
    const assets = await post(`app/injury-report/assets/${assetId}`)
    const parsedData = camelizeKeys(assets)
    return parsedData as Omit<MyAssetsAsset, 'buyoutDetails'>[]
  },

  acceptBuyoutOffer: async (buyOutOfferId: number) => {
    await post(`app/buyout/offers/${buyOutOfferId}/acceptance`)
    return true
  },
  declineBuyoutOffer: async (buyOutOfferId: number) => {
    await post(`app/buyout/offers/${buyOutOfferId}/rejection`)
    return true
  },
}

export default injuryreportResources
